import React, {Component} from "react"
import { connect } from 'react-redux';

class OpenAppButton extends Component {
    constructor() {
        super();

        this.handleClick = this.handleClick.bind(this);
    }

    componentDidMount() {
    }

    handleClick() {
        this.props.handleMapClick();
        window.open('https://www.pierinoijs.be/', "_blank");
    }
    
    render() {
        const buttonSrc = '/images/tracker/icon_button.png';
        const buttonTextSrc = '/images/tracker/icon_openapp.png';

        return (
            <div>
                <button
                    type="button"
                    className='trackerButton-wrapper'
                    onClick={(event) => {event.stopPropagation(); this.handleClick();}}
                    onKeyDown={(event) => {
                        if (event.key === 'Enter' || event.key === ' ') {
                            event.preventDefault();
                            event.stopPropagation();
                            this.handleClick();
                        }
                    }}
                    aria-label="Open de app in een nieuw venster"
                    style={{
                        background: 'none',
                        border: 'none',
                        padding: 0,
                        cursor: 'pointer',
                        display: 'inline-block'
                    }}
                >
                    <img src={buttonSrc} alt='' className='iconhand trackerButton' aria-hidden="true" />
                </button>
                <img src={buttonTextSrc} alt='Open de app' className='iconhand trackerButtonText' onClick={(event) => {event.stopPropagation(); this.handleClick();}}/>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
    }
}

export default connect(mapStateToProps)(OpenAppButton);